import { User } from '@wellesley/openapi'
import { FetchResponse } from '../types'

type GetLinkProps = {
  user: User
  template?: string
}

export const getDomainFromURL = (url: string) => {
  try {
    return url.startsWith('https') || url.startsWith('http')
      ? new URL(url).origin
      : new URL(`https://${url}`).origin
  } catch (e) {
    throw new Error(`Error getting domain from entered URL`)
  }
}

export const getTemplate = (data: FetchResponse) => {
  const link = data.links.find(
    (l) => l.rel === 'http://ostatus.org/schema/1.0/subscribe',
  )

  return link?.template
}

export const getLinkToOpen = ({ template, user }: GetLinkProps) =>
  template?.replace('{uri}', user.uri)
